import React from "react";
import { Button } from "antd";

export const PrintButtons = ({ printType, setPrintType }) => (
  <div className="print-buttons-container">
    <span className="buttons-instruction">
      Seleccione el formato de descarga de las etiquetas:
    </span>
    <div className="buttons-container">
      <Button
        className={printType === 1 ? "active-button" : null}
        onClick={() => setPrintType(1)}
      >
        Formato A4
      </Button>
      <Button
        className={printType === 2 ? "active-button" : null}
        onClick={() => setPrintType(2)}
      >
        Etiquetadora
      </Button>
    </div>
  </div>
);
